import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: () => import('@/views/Layout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/stats/Dashboard.vue'),
        meta: { title: '首页', icon: 'el-icon-s-home' }
      },
      {
        path: 'members',
        name: 'MemberList',
        component: () => import('@/views/member/List.vue'),
        meta: { title: '会员管理', icon: 'el-icon-user' }
      },
      {
        path: 'members/:id',
        name: 'MemberDetail',
        component: () => import('@/views/member/Detail.vue'),
        meta: { title: '会员详情', hidden: true }
      },
      {
        path: 'movies',
        name: 'MovieList',
        component: () => import('@/views/movie/List.vue'),
        meta: { title: '电影管理', icon: 'el-icon-video-camera' }
      },
      {
        path: 'activities',
        name: 'ActivityList',
        component: () => import('@/views/activity/List.vue'),
        meta: { title: '热门活动', icon: 'el-icon-picture-outline' }
      },
      {
        path: 'about',
        name: 'AboutList',
        component: () => import('@/views/about/List.vue'),
        meta: { title: '关于我们', icon: 'el-icon-document' }
      },
      {
        path: 'stores',
        name: 'StoreList',
        component: () => import('@/views/store/List.vue'),
        meta: { title: '加盟店管理', icon: 'el-icon-shop' }
      },
      {
        path: 'stores/:storeId/pay',
        name: 'StorePayList',
        component: () => import('@/views/store/PayList.vue'),
        meta: { title: '支付账号管理', hidden: true }
      },
      {
        path: 'orders',
        name: 'OrderList',
        component: () => import('@/views/order/List.vue'),
        meta: { title: '订单管理', icon: 'el-icon-tickets' }
      },
      {
        path: 'merchant-accounts',
        name: 'MerchantAccountList',
        component: () => import('@/views/merchant/List.vue'),
        meta: { title: '核销账户', icon: 'el-icon-key' }
      },
      {
        path: 'orders/:id',
        name: 'OrderDetail',
        component: () => import('@/views/order/Detail.vue'),
        meta: { title: '订单详情', hidden: true }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// 路由守卫：未登录跳转登录页
router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - VR电影购票系统` : 'VR电影购票系统'
  const token = localStorage.getItem('admin_token')
  if (to.path !== '/login' && !token) {
    next('/login')
  } else {
    next()
  }
})

export default router
